import apiReq from 'core/api';
import type { Project } from 'types/Project';

type ProjectListItem = { id?: string | number };

function extractFirstProjectId(data: unknown): string {
  if (Array.isArray(data)) {
    return String((data[0] as ProjectListItem | undefined)?.id ?? '');
  }
  if (data && typeof data === 'object' && 'items' in data) {
    const items = (data as { items?: ProjectListItem[] }).items;
    return String(items?.[0]?.id ?? '');
  }
  return '';
}

/** Первый доступный project_id пользователя (нужен для chats/create). */
export async function fetchDefaultProjectId(): Promise<string> {
  try {
    const data = await apiReq<unknown>('projects');
    return extractFirstProjectId(data);
  } catch {
    return '';
  }
}

export interface CreateProjectPayload {
  name: string;
  description: string;
  system_prompt: string;
  users: string[];
}

export const createProject = (data: CreateProjectPayload): Promise<Project | undefined> =>
  apiReq<Project>('projects', 'POST', data);

/** `GET /projects` — список проектов. */
export const listProjects = (): Promise<Project[] | undefined> => apiReq<Project[]>('projects');
